import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TextInputGroup } from 'v1/components/shared';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger
} from 'v5/design-system/Collapsible.js';
import { cn } from 'v5/platform/dom/cn';

const RateFee = ({
  label,
  value,
  unit,
  placeholder,
  defaultValue,
  maxValue,
  minValue,
  className,
  showCheckbox,
  appearance,
  size,
  onChange
}) => {
  const [showFee, setShowFee] = useState(showCheckbox && value);

  useEffect(() => {
    setShowFee(!!value);
  }, [value]);

  const toggleFee = value => {
    setShowFee(value);
    value ? onChange(defaultValue) : onChange(null);
  };

  const textInputGroup = (
    <>
      <TextInputGroup
        type="number"
        appearance={appearance}
        size={size}
        placeholder={placeholder}
        value={value}
        step="any"
        max={maxValue}
        min={minValue}
        prepend={{ text: unit }}
        onBlur={val => onChange(val)}
      />
    </>
  );

  if (!showCheckbox) {
    return textInputGroup;
  }

  return (
    <div className="tailwind-root contents">
      <Collapsible
        open={showFee}
        onOpenChange={toggleFee}
        className={cn('-mx-2 w-[calc(100%+var(--spacing)*4)]', className)}
      >
        <CollapsibleTrigger className="px-2">
          <div className="flex items-center gap-2 w-full text-left">
            {showFee && (
              <>
                <span className="rounded-full size-3 bg-brand-500 shrink-0" />
              </>
            )}
            {label}
          </div>
        </CollapsibleTrigger>
        <CollapsibleContent className="flex flex-row gap-2 px-2 -my-1 py-1">
          {textInputGroup}
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};

RateFee.defaultProps = {
  showCheckbox: true,
  appearance: 'outline',
  unit: '%',
  defaultValue: 20,
  maxValue: 100,
  minValue: 0,
  placeholder: 'Add fee'
};

RateFee.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  unit: PropTypes.string,
  defaultValue: PropTypes.number,
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  value: PropTypes.any,
  className: PropTypes.string,
  showCheckbox: PropTypes.bool,
  appearance: PropTypes.oneOf(['outline', 'underline']),
  size: PropTypes.oneOf(['S', 'M']),
  onChange: PropTypes.func
};

export default RateFee;
